export default {
  componentName: 'VuePageStack',
  keyName: 'stack-key',
  pushName: 'push',
  goName: 'go',
  replaceName: 'replace',
  backName: 'back',
  forwardName: 'forward'
};
